import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=36531814&"
import script from "./NewsLetter.vue?vue&type=script&lang=ts&"
export * from "./NewsLetter.vue?vue&type=script&lang=ts&"
import style0 from "./NewsLetter.vue?vue&type=style&index=0&id=36531814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports